import React, { useState } from "react";
import { showAlert } from "./DynamicComp/Alert";

const CancelOrderModal = ({ onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const cancellationReasons = [
    "Order created by mistake",
    "Item(s) not required anymore",
    "Incorrect address selected",
    "Cheaper alternative available",
    "Expected delivery time is too long",
    "Other",
  ];

  const handleConfirm = () => {
    // Check if any reason is selected
    if (!reason) {
      showAlert({
        type: "warning",
        message: "Please select a reason for cancellation.",
        title: "warning"
      });
      return;
    }
    
    // If "Other" is selected, use the text from the input box. Otherwise, use the selected reason.
    const finalReason = reason === "Other" ? otherReason : reason;

    // Check if the "Other" reason is empty when selected
    if (reason === "Other" && !finalReason.trim()) {
      showAlert({
        type: "warning",
        message: "Please specify your reason in the text box.",
        title: "warning"
      });
        return;
    }

    onConfirm(finalReason);
  };

  return (
    // Modal Backdrop
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      
      {/* Modal Content */}
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h3 className="text-xl font-bold mb-4">Confirm Cancellation</h3>
        <p className="text-gray-600 mb-6">Please select a reason for cancelling your order. This helps us improve our service.</p>
        
        {/* Reason Selection */}
        <div className="space-y-4">
          {cancellationReasons.map((r) => (
            <label key={r} className="flex items-center space-x-3 cursor-pointer">
              <input
                type="radio"
                name="cancellationReason"
                value={r}
                checked={reason === r}
                onChange={() => setReason(r)}
                className="h-4 w-4 text-red-600 border-gray-300 focus:ring-red-500"
              />
              <span className="text-gray-700">{r}</span>
            </label>
          ))}
          
          {/* Textarea for "Other" reason (appears only when "Other" is selected) */}
          {reason === "Other" && (
            <textarea
              className="w-full mt-2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all duration-300"
              rows="3"
              placeholder="Please specify your reason..."
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              autoFocus
            />
          )}
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 font-semibold transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 font-semibold transition-colors"
          >
            Confirm Cancellation
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelOrderModal;